import { Goal } from '@griply/types';

// A sub-goal is any goal with a parent. Mirrors the premium sub-goal limit:
// excluded-from-limits and completed sub-goals don't count toward the cap.
export const countUncompletedSubGoals = (goals: Goal[]): number =>
  goals.filter(
    ({ completedAt, parentIds, excludedFromLimits }) =>
      !excludedFromLimits && !!parentIds?.length && !completedAt,
  ).length;
